<template>
  <md-dialog :md-active.sync="isVisible" :md-backdrop="true">
    <md-dialog-title>Change Role</md-dialog-title>

    <md-dialog-content>
      <md-list>
        <md-list-item
          :key="currentRole"
          v-for="currentRole in validRoles"
          class="pointer"
        >
          <md-radio v-model="roles" :value="currentRole" />
          <span class="md-list-item-text">{{ currentRole }}</span>
        </md-list-item>
      </md-list>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-accent" @click="close()">Close</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { validRoles } from '../../../utils/Role.util';

export default {
  name: 'change-role-modal',
  props: ['updateRole'],
  watch: {
    async roles() {
      this.updateRole({ roles: this.roles, id: this.item.id });
    },
  },
  data() {
    return {
      isVisible: false,
      validRoles,
      roles: '',
      item: {},
    };
  },
  methods: {
    open(item) {
      this.item = item;
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.pointer:hover {
  background-color: #edf2f7;
  color: white;
}
</style>
